import { useNavigate } from "react-router-dom";
import styles from './GameCard.module.css';
import { getUrl } from "../../App";
import { TeamIcon } from '@shared/components/TeamCard/TeamCard'
import { useQuery } from '@tanstack/react-query';

const fetch_teams = async () => {
    const response = await fetch(`${getUrl()}/api/teams`, { credentials: 'include', });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
}


const GameCardOther = ({ game }) => {
    const navigate = useNavigate();

    // Define SVG dimensions and image sizes for responsiveness
    // ViewBox coordinates: 0,0 is top-left. Width and Height define the "canvas" size.
    // Images will be placed relative to this viewBox.
    const svgWidth = 300; // Logical width for the SVG canvas
    const svgHeight = 150; // Logical height for the SVG canvas
    const logoSize = 120; // Logical size for each logo

    // Calculate positions for logos and 'VS' text
    const team1LogoX = 10;
    const team1LogoY = (svgHeight - logoSize) / 2 - 20; // Vertically center
    const team2LogoX = svgWidth - logoSize - 10;
    const team2LogoY = (svgHeight - logoSize) / 2 + 20; // Vertically center
    const vsTextX = svgWidth / 2;
    const vsTextY = svgHeight / 2 + 10; // Adjust for vertical centering of text

    const teams = useQuery({
        queryKey: ['teams'],
        queryFn: () => fetch_teams(),
        staleTime: 5 * 60 * 1000, // Cache data for 5 minutes
        cacheTime: 5 * 60 * 1000,
    });

    if (teams.isLoading) {
        return (
            <div className="view-content">
                <div className="panel-header">
                    <h3>Team Detail View</h3>
                </div>
            </div >
        )
    }


    if (teams.isError) {
        return <div>Error loading teams: {teams.error.message}</div>;
    }

    if (!teams.data) {
        return <div>No teams found.</div>;
    }

    return (
        <div className={styles.event_card}>
            <div className={styles.event_header}>
                <svg
                    viewBox={`0 0 ${svgWidth} ${svgHeight}`}
                    className="w-full max-w-sm h-auto" // Responsive SVG
                    preserveAspectRatio="xMidYMid meet" // Maintain aspect ratio
                    aria-labelledby="match-title"
                    role="img"
                >
                    <title id="match-title">{`${teams.data.find(t => t.id === game.team1)?.name} vs ${teams.data.find(t => t.id === game.team2)?.name}`}</title>
                    {/* Team 1 Logo */}
                    <image
                        href={TeamIcon(teams.data.find(t => t.id === game.team1)?.team_id)}
                        x={team1LogoX}
                        y={team1LogoY}
                        width={logoSize}
                        height={logoSize}
                        alt={`${game.team1} logo`}
                        // Add an onerror handler for robust image loading
                        onError={(e) => {
                            e.target.onerror = null; // Prevent infinite loop
                            e.target.href = 'https://placehold.co/100x100/CCCCCC/000000?text=Error'; // Fallback
                        }}
                    />

                    {/* Team 2 Logo */}
                    <image
                        href={TeamIcon(teams.data.find(t => t.id === game.team2)?.team_id)}
                        x={team2LogoX}
                        y={team2LogoY}
                        width={logoSize}
                        height={logoSize}
                        alt={`${game.team2} logo`}
                        // Add an onerror handler for robust image loading
                        onError={(e) => {
                            e.target.onerror = null; // Prevent infinite loop
                            e.target.href = 'https://placehold.co/100x100/CCCCCC/000000?text=Error'; // Fallback
                        }}
                    />

                    {/* 'VS' Text Overlay */}
                    <text
                        x={vsTextX}
                        y={vsTextY}
                        textAnchor="middle" // Center horizontally
                        dominantBaseline="middle" // Center vertically
                        fontSize="48" // Larger font size for prominence
                        fontWeight="bold"
                        fill="#EF4444" // Tailwind red-500 equivalent
                        stroke="#FFFFFF" // White stroke for better visibility
                        strokeWidth="2"
                        className="font-inter opacity-90 drop-shadow-md" // Tailwind classes
                        aria-label="versus"
                    >
                        VS
                    </text>
                </svg>
                <h2>{teams.data.find(t => t.id === game.team1)?.name} vs {teams.data.find(t => t.id === game.team2)?.name}</h2>
                <h3>{game.half}</h3>
            </div>
            <div className={styles.event_content}>
                <div className={styles.my_button} onClick={() => navigate(`/video/${game.id}`)}>View Video Data</div>
            </div>

        </div>
    );
};

export default GameCardOther;